import { funcBlobStorageCommunicator } from '@/plugins/axios';

export const postFile = (formData, folder, filename) => {
  return funcBlobStorageCommunicator.post(
    `UploadBlob/${folder}/${filename}/`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  );
};


export const getFile = (folder, filename) => {
    const url = `GetBlob/${encodeURIComponent(filename)}${
        folder ? `?folder=${encodeURIComponent(folder)}` : ''
    }`;

    return funcBlobStorageCommunicator.get(url, {
        responseType: 'blob'
    });
};